import breadcrumbs from './Users_breadcrumbs';
import modals from './Users_modals';
import employees from './Users_employees';
import organizations from './Users_organizations';
import requests from './Users_requests';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
    modals,
    employees,
    organizations,
    requests,
  },
  state: {
    tab          : null,
    showed_filter: false,
  },
  getters: {
    tab          : ({tab}) => tab,
    showed_filter: ({showed_filter}) => showed_filter,
    table_filter : ({tables}) => (table_name, filter) => {
      let getTable = tables.find((table)=> table.name == table_name);
      let filteredTable = getTable.filter((item)=>item[filter.key]==filter.value);
    },
  },
  mutations: {
    SET_ACTIVE_TAB(state, value) {
      state.tab = value;
    },
    TOGGLE_FILTER(state) {
      state.showed_filter = !state.showed_filter;
    },
    SET_PAGINATION(state, obj) {
      let {value, table} = obj;
      let selectedTable = state.tables.find((object)=> object.name === table.name);
      selectedTable.pagination = value;
    },
    SHOW_NUMBER(state, obj) {
      let {selected, table} = obj;
      let selectedTable = state.tables.find((object)=> object.name === table.name);

      if (selected=='Показывать по 10') {
        selectedTable.pagination.rowsPerPage = 10;
      } else if (selected=='Показывать по 25') {
        selectedTable.pagination.rowsPerPage = 5;
      } else if (selected=='Показывать по 50') {
        selectedTable.pagination.rowsPerPage = 50;
      } else if (selected=='Показывать по 100') {
        selectedTable.pagination.rowsPerPage = 100;
      }
    },
    SET_PAGE(state, obj) {
      let {table, value} = obj;
      let selectedTable = state.tables.find((object)=> object.name === 'users_employees');
      selectedTable.pagination.page = value;
    },
    SET_TABLE(state, obj) {
      let {table, value} = obj;
      let selectedTable = state.tables.find((object)=> object.name === table.name);
      selectedTable.content.items = value;
      selectedTable.content.totalItems = value.length;
    },
  },

};
